import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { InvestorStatementItem } from '../../../models/admin/InvestorStatement';

interface StatementReplaceConfirmDialogProps {
  item: InvestorStatementItem;
  onCancel: () => void;
  onConfirm: () => void;
}

const StatementReplaceConfirmDialog: React.FC<StatementReplaceConfirmDialogProps> = ({
  item,
  onCancel,
  onConfirm,
}) => (
  <Dialog open onClose={onCancel}>
    <DialogTitle>Replace existing statement?</DialogTitle>
    <DialogContent>
      {item.investmentEntityName} already has a confirmed statement in their investor documents.
      Confirming this one will replace it — the prior statement will no longer be available.
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel}>Cancel</Button>
      <Button variant="contained" color="warning" onClick={onConfirm}>
        Replace
      </Button>
    </DialogActions>
  </Dialog>
);

export default StatementReplaceConfirmDialog;
